module.exports = __webpack_public_path__ + "static/media/teemat.5cb7d6f7.svg";